<script setup>
import { ref, computed, onMounted, onUpdated } from "vue";
import axios from "axios";
import { useStore } from "@/store/authStore";
import { format } from "date-fns";
import { useCodeStore } from "@/store/codeStore";
import SearchArticleDialog from "../components/SearchArticleDialog.vue";
import { useApiStore } from "@/store/apiStore";
import { useRoleStore } from "@/store/roleStore";
import useRole from "@/components/role";
import { Modal, Tooltip } from "bootstrap";

// ツールチップ使用準備
new Tooltip(document.body, {
  selector: "[data-bs-toggle='tooltip']",
});

const { hasPermission } = useRole();

const registArticleMax = 10;

const roleStore = useRoleStore();
const apiStore = useApiStore();

const codeStore = useCodeStore();
const places = codeStore.places;
const store = useStore(); // Pinia storeを使用します
const accessToken = computed(() => {
  if (store.getAuthToken) {
    return store.getAuthToken; // 「payload」オブジェクトの中の「name」フィールドを取得します
  } else {
    return null;
  }
});

const tokenHeaders = {
  headers: {
    Authorization: `Bearer ${accessToken.value}`,
  },
};

const dragIndex = ref(null);

let SearchArticleModal = null;
onMounted(() => {
  SearchArticleModal = new Modal(document.getElementById("SerchArticleDialog"));
});

onUpdated(() => {
  // テキスト省略属性の要素を取り出す
  const elements = document.querySelectorAll(".text-truncate");
  // テキスト省略されていたらTooltipを実装にする
  elements.forEach((el) => {
    if (isEllipsisActive(el)) {
      const text = el.textContent;
      el.setAttribute("data-bs-toggle", "tooltip");
      el.setAttribute("data-bs-placement", "bottom");
      el.setAttribute("data-bs-original-title", text);
    }
  });
});

const isEllipsisActive = (el) => {
  return el.offsetWidth < el.scrollWidth;
};

const apiUrl = apiStore.getRankingPath;

// 初期値を設定
const update_date = ref("");

const results = ref([]);

const getResults = async () => {
  const response = await axios
    .get(apiUrl, tokenHeaders)
    .catch(function (error) {
      alert("更新エラー\n" + error);
    });
  if (!response) {
    console.log("更新エラー");
    return;
  }
  if (response.data.registDate == null || response.data.ranking == null) {
    console.log("データがありません");
    return;
  }
  update_date.value = formattedDate(response.data.registDate);
  results.value = response.data.ranking;
};

getResults();

const register = async () => {
  var sendUpdateRequest = {};
  sendUpdateRequest.ranking = [];
  for (var i = 0; i < results.value.length; i++) {
    var senddt = {};
    senddt.articleVideoType = results.value[i].articleVideoType;
    senddt.id = results.value[i].id;
    sendUpdateRequest.ranking[i] = senddt;
  }
  const response = await axios
    .put(apiUrl, sendUpdateRequest, tokenHeaders)
    .catch(function (error) {
      console.log(error.toJSON());
      alert("登録エラー\n" + error);
    });
  if (!response) {
    console.log("登録エラー");
    return;
  }
  alert("登録されました。");
};

const getMatchedText = (value, list) => {
  if (value == null) {
    return "";
  }
  const trimmedValue = value.toString().trim();
  const item = list.find((p) => p.value == trimmedValue);
  return item ? item.text : value;
};

const dragStart = (index) => {
  dragIndex.value = index;
};

const dragEnter = (index) => {
  console.log("dragenter:" + index + " dragindex:" + dragIndex.value);
  if (index === dragIndex.value) return;
  const deleteElement = results.value.splice(dragIndex.value, 1)[0];
  results.value.splice(index, 0, deleteElement);
  dragIndex.value = index;
};

const dragEnd = () => {
  dragIndex.value = null;
};

const del = (index) => {
  results.value.splice(index, 1);
};

// ダイアログ結果処理
const dialogResult = async (obj) => {
  console.log(obj);
  if (!obj.res) {
    return;
  }
  if (results.value.length >= registArticleMax) {
    alert(
      "記事の登録件数をオーバーしています(最大" +
        registArticleMax.toString() +
        "件)。"
    );
    SearchArticleModal.hide();
    return;
  }

  if (
    results.value.findIndex(
      (e) =>
        e.id === obj.article.id &&
        e.articleVideoType === obj.article.articleVideoType
    ) != -1
  ) {
    alert("既に記事が存在します。");
    return;
  }
  results.value.push(obj.article);
  SearchArticleModal.hide();
};

const formattedDate = (dateStr) => {
  if (!dateStr) return "";
  return format(new Date(dateStr), "yyyy/MM/dd HH:mm");
};
</script>

<template>
  <div>
    <div class="d-flex justify-content-between col-12">
      <div>
        最大１０件登録できます<br />
        項目をドラッグすることで順位を変更できます
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <div>登録日時:{{ update_date }}</div>
      </div>
    </div>
    <div class="fixed-table table-responsive">
      <table
        class="result_table table-striped table-bordered"
        aria-colspan="8"
        style="border: none"
      >
        <thead>
          <tr class="result_table_th">
            <th>No</th>
            <th>ID</th>
            <th>タイプ</th>
            <th>タイトル</th>
            <th>レース場</th>
            <th>タグ</th>
            <th class="table_date">公開日時</th>
            <th class="table_pr">PR</th>
            <th class="table_delete_button"></th>
          </tr>
        </thead>
        <tbody class="result_tbody_bgcolor">
          <tr
            v-for="(result, index) in results"
            :key="result.id"
            :draggable="true"
            @dragstart="dragStart(index)"
            @dragenter="dragEnter(index)"
            @dragover.prevent
            @dragend="dragEnd"
            :class="[index === dragIndex ? 'dragging' : '']"
          >
            <td class="text-end">{{ index + 1 }}</td>
            <td class="table_id">{{ result.id }}</td>
            <td class="table_type">
              {{ result.articleVideoType === "1" ? "記事" : "動画" }}
            </td>
            <td class="table_title text-truncate">{{ result.title }}</td>
            <td class="table_race">
              {{ getMatchedText(result.boatraceCourse, places) }}
            </td>
            <td class="table_tag text-truncate">{{ result.tag }}</td>
            <td class="table_date">{{ formattedDate(result.date) }}</td>
            <td class="table_pr">{{ result.pr == "1" ? "PR" : "" }}</td>
            <td class="table_delete_button">
              <button class="submit_button" @click="del(index)">削除</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="d-flex justify-content-between col-12 mt-3 mb-3">
      <button class="submit_button" @click="SearchArticleModal.show()">
        記事検索
      </button>
      <button
        :disabled="!hasPermission(roleStore.role, 'ARTICLE_RANKING')"
        class="submit_button"
        v-on:click="register"
      >
        登録
      </button>
      <SearchArticleDialog caller="Ranking" @result="dialogResult" />
    </div>
  </div>
</template>

<style scoped>
table,
th,
td {
  border-collapse: collapse;
  padding: 0.3rem;
}

.table_title {
  min-width: 20rem;
  max-width: 20rem;

  white-space: nowrap;
}

.table_id {
  min-width: 6em;
  max-width: 6em;
}

.table_type {
  min-width: 4em;
  max-width: 4em;
}
.table_race {
  min-width: 5.5em;
  max-width: 5.5em;
}

.table_tag {
  min-width: 12rem;
  max-width: 12rem;

  white-space: nowrap;
}
.table_date {
  min-width: 8rem;
  max-width: 8rem;
  white-space: nowrap;
}
.table_pr {
  text-align: center;
  min-width: 2em;
  max-width: 2em;
}
.table_delete_button {
  text-align: center;
  min-width: 7em;
  max-width: 7em;
  padding: 0;
}

.dragging {
  background-color: #2c2c2c;
}
</style>
